import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import swal from "sweetalert";
import apiRouteList from "../../config/api-route-list-config";
import { RolePermissionContext } from "../../contexts/RolePermissionContext";
import SubmitButton from "../Buttons/SubmitButton";
import RolePermissionCard from "../Cards/RolePermissionCard";

export default function RoleEdit({ id }) {
    const [roleData, setRoleData] = useState([]);
    const [roleName, setRoleName] = useState(null);
    const [processing, setProcessing] = useState(false);
    const [, setError] = useState({});
    const rolePermissionCtx = useContext(RolePermissionContext);
    const [t] = useTranslation();

    const updatePermissionHandler = async (e) => {
        setProcessing(true);
        //preparing form data
        e.preventDefault();

        //geting backend api
        const updateRoleApi = apiRouteList.loggedRoutes.updateRoleByID;

        try {
            await axios({
                method: updateRoleApi.method,
                url: updateRoleApi.endpoint + id,
                data: {
                    name: roleName,
                    permissions: rolePermissionCtx.permissionArr,
                },
                headers: updateRoleApi.headers,
            })
                .then((response) => {
                    setProcessing(false);
                    rolePermissionCtx.setPermissionArr([]);
                    swal(
                        t("Successfull"),
                        t("Successfully updated role permission!"),
                        "success"
                    );
                })
                .catch((error) => {
                    swal(
                        t("Unsuccessful"),
                        t("Something went wrong!"),
                        "error"
                    );
                    setProcessing(false);
                });
        } catch (error) {
            setProcessing(false);
        }
    };

    useEffect(() => {
        rolePermissionCtx.setPermissionArr([]);
        const showRoleHandler = async (e) => {
            setProcessing(true);

            //geting backend api
            let roleShowApi = apiRouteList.loggedRoutes.getRoleByID;

            try {
                await axios({
                    method: roleShowApi.method,
                    url: roleShowApi.endpoint + id,
                    headers: roleShowApi.headers,
                })
                    .then((response) => {
                        setProcessing(false);
                        const data = response.data;
                        setRoleName(data.data.name);
                        rolePermissionCtx.setPermissionArr(
                            data.data.permissionIds
                        );
                        let array = [];
                        let permissionModules = data.data.modules;
                        for (const key in permissionModules) {
                            array.push(
                                <RolePermissionCard
                                    permittedId={data.data.permissionIds}
                                    title={key}
                                    permissionList={data.data.modules[key]}
                                />
                            );
                        }
                        setRoleData(array);
                    })
                    .catch((error) => {
                        setError(error.response.data.errors);
                        setProcessing(false);
                    });
            } catch (error) {
                setProcessing(false);
            }
        };

        showRoleHandler();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    return (
        <>
            <div className="rounded-md overflow-hidden">
                <div className="bg-white dark:bg-slate-800 px-5 py-7 border-b border-b-slate-100 dark:border-b-slate-900">
                    <h1 className="font-Outfit text-2xl text-black dark:text-white font-semibold">
                        {t("Edit Role")}
                    </h1>
                </div>
                <div className="bg-white dark:bg-slate-800 px-5 py-7 ">
                    <form onSubmit={(e) => updatePermissionHandler(e)}>
                        <div className="input-group">
                            <label htmlFor="name" className="inputLabel">
                                {t("Role Name")}
                            </label>

                            <input
                                type="text"
                                defaultValue={roleName}
                                id="name"
                                className="inputField2 w-full"
                                placeholder={t("Enter role name")}
                                required
                                onChange={(e) => setRoleName(e.target.value)}
                            />
                        </div>
                        <h3 className="font-Outfit font-semibold text-xl text-black dark:text-white py-5">
                            {t("Update Permissions")}
                        </h3>
                        <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-7">
                            {roleData}
                        </div>
                        <SubmitButton processing={processing}>
                            {t("Save Changes")}
                        </SubmitButton>
                    </form>
                </div>
            </div>
        </>
    );
}
